<template>
    <a-form-model ref="adminForm" :rules="rules" :layout="formLayout" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="ชื่อ">
            <a-input v-model="form.firstname" placeholder="input placeholder">
                <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
            </a-input>
        </a-form-model-item>
        <a-form-model-item label="นามสกุล">
            <a-input v-model="form.lastname" placeholder="input placeholder">
                <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
            </a-input>
        </a-form-model-item>
        <a-form-model-item label="เบอร์โทร">
            <a-input v-model="form.phoneNumber" placeholder="input placeholder">
                <a-icon slot="prefix" type="phone" style="color:rgba(0,0,0,.25)" />
            </a-input>
        </a-form-model-item>
        <a-form-model-item label="อีเมลล์">
            <a-input v-model="form.email" placeholder="input placeholder">
                <a-icon slot="prefix" type="email" style="color:rgba(0,0,0,.25)" />
            </a-input>
        </a-form-model-item>
        <a-form-model-item label="สิทธิ์เข้าใช้งาน" prop="roleAdminId">
            <a-select v-model="form.roleAdminId">
                 <a-select-option value="">เลือกสิทธิ์เข้าใช้งาน</a-select-option>
                <a-select-option  v-for="roleAdmin in roleAdmin"  :key='roleAdmin.id' :value="roleAdmin.id">
                    {{roleAdmin.name}}
                </a-select-option>
            </a-select>
        </a-form-model-item>
        <div class="mb-4 border-bottom"></div>
        <a-form-model-item label="ยูสเซอเนม" prop="username" :validate-status="(errorForm.username)?'error':''" >
            <a-input v-model="form.username"  placeholder="input placeholder">
                <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
            </a-input>
        </a-form-model-item>
        <a-form-model-item label="รหัสผ่าน">
            <a-input-password v-model="form.password" placeholder="input placeholder">
                <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
            </a-input-password>
        </a-form-model-item>
         <a-form-model-item label="ยืนยันรหัสผ่าน">
            <a-input-password v-model="form.reCheckPassword" placeholder="input placeholder">
                <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
            </a-input-password>
        </a-form-model-item>
        <a-form-model-item >
            <a-button type="primary" @click="onSubmit" :loading="isloading">
                ยืนยัน
            </a-button>
            <a-button style="margin-left: 10px;" @click="onCancel">
                ยกเลิก
            </a-button>
        </a-form-model-item>
    </a-form-model>
</template>

<script>

export default {
  data() {
    return {
      errorForm: [],
    }
  },
  props: [
    'form',
    'formLayout',
    'labelCol',
    'wrapperCol',
    'roleAdmin',
    'rules',
    'isloading',
    'error',
    'validate',
  ],
  watch: {
    error() {
      if (this.error) {
        // this.errorForm.username = true
        this.$refs.adminForm.validateField(['username'], (errors, values) => {
          // console.log('error', values)
        })
        // validate-status="error"
        // help="Should be combination of numbers & alphabets"
      }
    },
  },
  methods: {
    async onSubmit() {
      this.$refs.adminForm.validate(valid => {
        if (valid) {
          this.$emit('return-form', { form: this.form })
        }
      })
    },
    onCancel() {
      this.$emit('close-form', this.form)
    },
  },
}
</script>

<style>

</style>
